import { autocomplete } from './autocomplete.js';
import { backdrop } from './backdrop.js';
import { card } from './card.js';
import { checkbox } from './checkbox.js';
import { datePicker } from './date-picker.js';
import { dialog } from './dialog.js';
import { drawer } from './drawer.js';
import { form } from './form.js';
import { menu } from './menu.js';
import { dataGrid } from './mui-x-data-grid.js';
import { paper } from './paper.js';
import { popover } from './popover.js';
import { select } from './select.js';
import { stack } from './stack.js';
import { stepper } from './stepper.js';
import { svgIcon } from './svg-icon.js';
import { table } from './table.js';
import { tabs } from './tabs.js';
import { textfield } from './textfield.js';

export const components = {
  ...autocomplete,
  ...backdrop,
  ...card,
  ...checkbox,
  ...datePicker,
  ...drawer,
  ...form,
  ...dialog,
  ...dataGrid,
  ...menu,
  ...paper,
  ...popover,
  ...select,
  ...stack,
  ...svgIcon,
  ...stepper,
  ...table,
  ...tabs,
  ...textfield,
};
